import { createBrowserRouter, Navigate, RouterProvider, useLocation } from "react-router";
import { AboutPage } from "@/site/about";
import { CertificateView } from "@/site/certificate";
import { Home } from "@/site/home";
import { Identify } from "@/site/identify";
import { NotFound } from "@/site/not-found";
import { RecordingPage } from "@/site/recording";
import { RegistryPage } from "@/site/registry";
import { SharkRecord } from "@/site/shark";
import { Shell } from "@/site/shell";

/** The registry was called the register; its shared links keep working, search and all. */
function RegisterLink() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/registry", search }} replace />;
}

// Public URLs: /certificate/:id links are shared, so these paths must not change.
const router = createBrowserRouter([
  {
    element: <Shell />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/identify/:queryId", element: <Identify /> },
      { path: "/recording/:recordingId", element: <RecordingPage /> },
      { path: "/shark/:id", element: <SharkRecord /> },
      { path: "/certificate/:id", element: <CertificateView /> },
      { path: "/registry", element: <RegistryPage /> },
      { path: "/register", element: <RegisterLink /> },
      { path: "/about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
